<div class="th-menulevel modal">
  <div class="ir-btn ir-btn--big th-btn-remove" (click)="selectMenu(1)">
    <span>{{ 'menus.delete-comment' | translate }}</span>
  </div>
</div>
